<div class="flex gap-1 items-center">
  <!--  <ng-icon name="heroChartBar" class="text-proffeo-muted text-base"></ng-icon>-->
  <span class="text-proffeo-muted text-sm">
    {{ 'task-details-modal-changed-progress' | translate }}: {{ activity()?.data?.to }} %
  </span>
</div>
